import { clsx } from "clsx";
import type { ICardSectionProps } from "./types";

export const CardBody = ({ className, children }: ICardSectionProps) => (
  <div className={clsx("nuco-card__body", className)}>{children}</div>
);

export const CardFooter = ({ className, children }: ICardSectionProps) => (
  <div className={clsx("nuco-card__footer", className)}>{children}</div>
);
